import { themeColors } from "@/utils/themeColors";

export const AuthTitle = ({ children, ...props }: React.HTMLAttributes<HTMLHeadElement>) => {
    return (
        <h2
            className="heading3"
            {...props}
            data-testid="auto-id-879e1192-0e2e-45cb-b40a-79baa0b25fa4">
            {children}
        </h2>
    );
};

export const AuthDescription = ({ style, children }: React.HTMLAttributes<HTMLParagraphElement>) => {
    return (
        <p
            className="body2"
            style={{ color: themeColors.neutral3, ...style }}
            data-testid="auto-id-8ed55365-fb58-4463-be31-02d8ff1028f0">
            {children}
        </p>
    );
};
